import { IconNames } from '@blueprintjs/icons';
import { GridWithFilters, PrimaryData, SecondaryData } from '@strata/react-grid';
import { Icon } from '@strata/react-status-icons';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';
import { getPayerMap } from 'services/PayerSegmentSupport';

const columns = ({ navigate }) => [
    {
        header: 'Payer Segment Name',
        accessorKey: 'segment_name',
        size: 200,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        header: 'Payer Segment ID',
        accessorKey: 'segment_id',
        size: 120,
    },
    {
        header: 'Payer',
        accessorKey: 'payer_id',
        size: 120,
        cell: ({ getValue, row }) => (
            <SecondaryData data={`${row.original.payerName} - ${getValue()}`} />
        ),
    },
    {
        header: 'Restricted Group IDs',
        accessorKey: 'restrictedGroups',
        size: 120,
        cell: ({ getValue }) => <SecondaryData data={getValue()?.join(', ')} />,
    },
    {
        header: 'Actions',
        accessorKey: 'actions',
        size: 70,
        enableSorting: false,
        cell: ({ row }) => (
            <div className="sds_filter-list__actions">
                <Icon
                    icon={IconNames.EDIT}
                    intent={Icon.Intent.SECONDARY}
                    title="Edit"
                    onClick={() =>
                        navigate({
                            pathname: `/payer-segment/${row.original.segment_id}`,
                        })
                    }
                />
            </div>
        ),
    },
];

export const PayerSegmentList = () => {
    const navigate = useNavigate();
    const payerSegments = useGet('/reference/payer_segments');
    const payers = useGet('/reference/payers/');
    const payerMap = getPayerMap(payers);
    const restrictedGroupsMap = useGet('/aperture/restricted_groups');

    const data = useMemo(
        () =>
            payerSegments?.map((segment) => ({
                ...segment,
                payerName: payerMap?.[segment.payer_id],
                restrictedGroups: restrictedGroupsMap?.[segment.segment_id],
            })),
        [payerSegments, payerMap, restrictedGroupsMap],
    );

    return (
        <div className="sds_filter-list">
            <GridWithFilters
                headerContent={
                    <ListPageHeader
                        pageTitle="Payer Segments"
                        buttons={[
                            {
                                label: 'Create Payer Segment',
                                path: `/payer-segment/${CREATE_ROUTE}`,
                            },
                        ]}
                    />
                }
                enableSearch
                isLoading={!(payerSegments && payers && restrictedGroupsMap)}
                data={data}
                sortProperties={[{ id: 'segment_name', desc: false }]}
                filterCategories={[
                    {
                        key: 'payerName',
                        title: 'Payer',
                        showCounts: true,
                    },
                ]}
                columns={columns({ navigate })}
            />
        </div>
    );
};
